<template>
    <div class="index">
        <div class="top">
            <div class="title">
                <div class="name">
                    <div class="padding"></div>
                    订单统计
                </div>
            </div>
            <div>
                <ul>
                    <li>
                        <div class="value">{{ census.i }}</div>
                        <div class="key">全部</div>
                    </li>
                    <li>
                        <div class="value">{{ census.i1 }}</div>
                        <div class="key">待审核</div>
                    </li>
                    <li>
                        <div class="value">{{ census.i2 }}</div>
                        <div class="key">待结算</div>
                    </li>
                    <li>
                        <div class="value">{{ census.i3 }}</div>
                        <div class="key">结算确认</div>
                    </li>
                    <li>
                        <div class="value">{{ census.i5 }}</div>
                        <div class="key">待收款</div>
                    </li>
                    <li>
                        <div class="value">{{ census.i6 }}</div>
                        <div class="key">完结</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bottom">
            <div class="title">
                <div class="name">
                    <div class="padding"></div>
                    接单大厅
                </div>
            </div>
            <div>
                <div class="tabbar">
                    <div style="display: flex;align-items: center;">
                        <span style="width: 60px;">随机码：</span>
                        <el-input placeholder="请填写随机码" v-model="needP" clearable></el-input>
                    </div>
                    <el-button style="margin: 0px 20px;" type="primary" @click="getDraw">提取</el-button>
                </div>
                <custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection"
                              :buttonGroup="buttonGroup" :filterValue="filterValue" :tableFilter="tableFilter"
                              :tableConfig="tableConfig" :tableData="tableData" @pageChange="pageChange"
                              @buttonClick="buttonClick" @filterChange="filterChange"
                              @scopeButtonClick="scopeButtonClick">
                </custom-table>
            </div>
        </div>
        <el-dialog title="订单" :visible.sync="dialogVisible" width="40%">
            <div class="title">
                <div class="name">
                    <div class="padding"></div>
                    订单详情
                </div>
            </div>
            <div style="display: flex;flex-wrap: wrap;">
                <div class="item address-box" v-for="(item, index) in formConfig">
                    <p class="tit1">{{ item.title }}</p>
                    <div class="address-box1">
                        <template v-if="item.type === 'input'">
                            <el-input class="address_input" v-model="form[item.prop]" :placeholder="item.placeholder"
                                      size="medium" disabled>
                                <template slot="prepend" v-if="item.prepend">{{ item.prepend }}</template>
                                <template slot="append" v-if="item.append">{{ item.append }}</template>
                            </el-input>
                        </template>
                        <template v-else-if="item.type === 'textarea'">
                            <textarea v-model="form[item.prop]" :placeholder="item.placeholder" disabled></textarea>
                        </template>
                    </div>
                </div>
            </div>
            <div class="title">
                <div class="name">
                    <div class="padding"></div>
                    确认信息
                </div>
            </div>
            <el-form :model="form1" :rules="rules1" ref="form1" label-width="120px" style="margin: 10px 0px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="单价（元/天）" prop="money">
                            <el-input v-model="form1.money"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作天数" prop="day">
                            <el-input v-model="form1.day"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="职责" prop="response">
                    <el-input v-model="form1.response"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="recover">提 取</el-button>
			</span>
        </el-dialog>
    </div>

</template>

<script>
import api from '@/http/electrician/api.js';
import {mapGetters} from 'vuex';

export default {
    name: 'index',
    data() {
        return {
            needP:null,
            pageConfig: {
                totalWord: '全部数据',
                total: 0,
                pageSize: 10,
                currentPage: 1
            },
            multipleSelection: [],
            buttonGroup: [],
            filterValue: {},
            tableFilter: [],
            tableConfig: {
                selection: true,
                tableHeader: [{
                    prop: 'title',
                    label: '工程名称',
                    width: 200
                },
                    {
                        prop: 'need',
                        label: '用工需求',
                        width: 250
                    },
                    {
                        prop: 'introduction',
                        label: '工程简介',
                        width: 250
                    },
                    {
                        prop: 'address',
                        label: '作业地点',
                        width: 200
                    }
                    // ,{
                    // 	prop: 'days',
                    // 	label: '工期（天）',
                    // 	width: 100
                    // },{
                    // 	prop: 'number',
                    // 	label: '人数',
                    // 	width: 100
                    // },{
                    // 	prop: 'price',
                    // 	label: '总价（元）',
                    // 	width: 100
                    // }
                    , {
                        prop: 'orderStatus',
                        label: '状态',
                        width: 120
                    }
                ],
                tableEvent: [{
                    icon: 'el-icon-search',
                    name: '查看',
                    color: 'green',
                    sign: 'select'
                }
                    // {
                    // 	icon: 'el-icon-search',
                    // 	name: '接受',
                    // 	color: 'blue',
                    // 	sign: 'update'
                    // },
                    // {
                    // 	icon: 'el-icon-search',
                    // 	name: '拒绝',
                    // 	color: 'red',
                    // 	sign: 'delete'
                    // }
                ],
                emptyDescription: '当前没有数据'
            },
            tableData: [],

            // 上面统计
            census: {
                i: 0,
                i1: 0,
                i2: 0,
                i3: 0,
                i5: 0,
                i6: 0
            },
            dialogVisible: false,//弹窗
            form: {
                title: '',
                need: '',
                introduction: '',
                ability: '',
                qualification: '',
                address: '',
                instruction: '',
                price: '',
                number: '',
                days: '',
                up: '',
                down: ''
            },
            formConfig: [
                {
                    type: 'input',
                    title: '工程名称：',
                    prop: 'title',
                    placeholder: '请输入工程名称',
                }, {
                    type: 'input',
                    title: '用工需求：',
                    prop: 'need',
                    placeholder: '请输入用工需求'
                }, {
                    type: 'input',
                    title: '工程简介：',
                    prop: 'introduction',
                    placeholder: '请输入工程简介'
                }, {
                    type: 'input',
                    title: '工程所需技能：',
                    prop: 'ability',
                    placeholder: '请输入工程所需技能'
                }, {
                    type: 'input',
                    title: '工程所需资质：',
                    prop: 'qualification',
                    placeholder: '请输入工程所需资质'
                }, {
                    type: 'input',
                    title: '工作地点：',
                    prop: 'address',
                    placeholder: '请输入工作地点'
                }, {
                    type: 'input',
                    title: '接单说明：',
                    prop: 'instruction',
                    placeholder: '请输入接单说明'
                }
                // , {
                // 	type: 'input',
                // 	title: '计划工程总额（元）：',
                // 	prop: 'price',
                // 	placeholder: '请输入计划工程总额（元）',
                // 	prepend: '总价',
                // 	append: '/￥'
                // } , {
                // 	type: 'input',
                // 	title: '人数限制：',
                // 	prop: 'number',
                // 	placeholder: '请输入人数限制',
                // 	append: '/人'
                // } , {
                // 	type: 'input',
                // 	title: '预计工期（天）：',
                // 	prop: 'days',
                // 	placeholder: '请输入预计工期',
                // 	prepend: '时长',
                // 	append: '/天'
                // } , {
                // 	type: 'input',
                // 	title: '单价上限（人/天）：',
                // 	prop: 'up',
                // 	placeholder: '请输入单价上限（人/天）',
                // 	append: '/￥'
                // } , {
                // 	type: 'input',
                // 	title: '单价下限（人/天）：',
                // 	prop: 'down',
                // 	placeholder: '请输入单价下限（人/天）',
                // 	append: '/￥'
                // }
            ],
            //
            form1: {
                money: '',
                day: '',
                response: ''
            },
            rules1: {
                money: [
                    {required: true, message: '请填写单价（元/天）', trigger: 'blur'}
                ],
                day: [
                    {required: true, message: '请填写工作天数', trigger: 'blur'}
                ],
                response: [
                    {required: true, message: '请填写职责', trigger: 'blur'}
                ]
            }
        };
    },
    methods: {
        // 页面变化
        pageChange() {
            this.getIndexOrderList()
        },
        // 右上按钮
        buttonClick(sign) {

        },
        // 筛选条件变化
        filterChange() {
        },
        // 操作按钮
        scopeButtonClick(row, sign) {
            if (sign === 'select') {
                this.$router.push({
                    path: '/electricianUser/eleDetail',
                    query: {
                        id: row.id
                    }
                });
            }
            if (sign === 'update') {
                this.$router.push({
                    path: '/electricianUser/eleDetail',
                    query: {
                        id: row.id
                    }
                })
            }
            if (sign === 'delete') {
                this.$confirm('您确定要拒绝当前订单吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.refuseOrderApi({
                        id: row.id
                    }).then(res => {
                        this.getIndexOrderList()
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        })
                    })
                })
            }
        },

        getIndexOrderList() {
            api.getNearRest({
                pageSize: this.pageConfig.pageSize,
                pageNum: this.pageConfig.currentPage
            }).then(res => {
                if (res.code == 200) {
                    let list = res.rows;
                    let array = new Array();
                    for (let i = 0; i < list.length; i++) {
                        let obj = {
                            title: list[i].title,
                            need: list[i].need,
                            introduction: list[i].introduction,
                            address: list[i].address,
                            days: list[i].days,
                            number: list[i].number,
                            price: list[i].price,
                            orderStatus: this.formatStatus(list[i].orderStatus),
                            id: list[i].id
                        };
                        array.push(obj);
                    }
                    this.tableData = array;
                    this.pageConfig.total = res.total;
                }
            });
        },
        getIndexOrderStatistics() {
            api.selectCountNeedOrder().then(res => {
                if (res) {
                    this.census = res;
                }
            })
        },
        // 查看 提取 的 订单
        getDraw() {
            api.addOrder({needP: this.needP}).then(res => {
                if (res) {
                    this.dialogVisible = true;
                    this.form = res;
                }
            });
        },
        // 接单
        recover() {
            let data = {
                ...this.form1,
                price: this.form1.money * this.form1.day,
                needP: this.needP,
                needId: this.form.id
            };
            this.$refs['form1'].validate((valid) => {
                if (valid) {
                    api.editOrder(data).then(res => {
                        if (res) {
                            this.$message.success("提取成功");
                            this.dialogVisible = false;
                            this.getIndexOrderList();
                            this.needP = "";
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        // 格式化
        formatStatus(obj) {
            const data = this.orderStatus.find(item => item.value === obj);
            if (data) {
                return data.label;
            }
            return "";
        },
    },
    mounted: function () {
        //模板编译/挂载之后
        this.getIndexOrderList();
        this.getIndexOrderStatistics();
    },
    computed: {
        ...mapGetters(['needStatus', 'orderStatus'])
    }
};
</script>

<style lang="less" scoped="scoped">
.index {
  width: 100%;

  .top, .bottom {
    width: 100%;
    background: @vue-bg-color;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
  }

  .top {
    ul {
      width: 100%;
      padding: @vue-spacing-col-base 0px;
      display: flex;
      justify-content: space-between;

      li {
        width: 25%;
        border-right: 1px solid @vue-border-color;
        box-sizing: border-box;

        .value,
        .key {
          width: 100%;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .value {
          font-size: @vue-font-size-sm + 2;
          font-weight: bold;
        }

        .key {
          color: @vue-text-color-grey;
          font-size: @vue-font-size-sm - 2;
        }

        .line {
          width: 100%;
          height: 30px;
          display: flex;
          align-items: center;
          font-size: @vue-font-size-sm - 2;

          span {
            color: @vue-text-color-grey;
            margin-right: @vue-spacing-row-sm;
          }
        }
      }

      /*li:first-child {*/
      /*display: flex;*/

      /*.cont,*/
      /*.type {*/
      /*width: 50%;*/
      /*}*/
      /*}*/

      li:last-child {
        border: none;
      }
    }
  }

  .bottom {
    margin-top: @vue-spacing-col-lg;
  }

  .title {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid @vue-border-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .name {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .padding {
      width: 4px;
      height: 16px;
      background: #ff5252;
      margin-right: @vue-spacing-row-sm;
    }
  }

  .content {
    width: 100%;
  }

  .tabbar {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: flex-end;
    padding: 0px @vue-spacing-row-base;
    box-sizing: border-box;
  }

  .table {
    width: 100%;
    height: 810px;
  }

  .address-box {
    width: 50%;
    display: flex;
    align-items: center;
    margin: 5px 0px;

    .tit1 {
      width: 140px;
      text-align: end;
    }

    .address-box1 {
      width: 200px;
    }
  }
}
</style>
